export default __webpack_public_path__ + "static/media/Snd_TryR.aa9bb341.mp3";